// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".action[data-v-1cdd0f58]{border:2px solid #f18241!important;color:#f18241}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
